import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "messagesContainer", "submitButton", "form"]
  static values = {
    url: String
  }

  connect() {
    this.scrollToBottom()
  }

  async submit(event) {
    event.preventDefault()

    const content = this.inputTarget.value.trim()
    if (!content) return

    this.disableInput()
    this.inputTarget.value = ""

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({ content: content })
      })

      if (!response.ok) {
        throw new Error("Failed to send message")
      }
    } catch (error) {
      console.error("Error sending message:", error)
      this.showError("Failed to send message. Please try again.")
    } finally {
      this.enableInput()
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.submit(event)
    }
  }

  disableInput() {
    this.inputTarget.disabled = true
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
  }

  enableInput() {
    this.inputTarget.disabled = false
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    this.inputTarget.focus()
  }

  showError(message) {
    const errorDiv = document.createElement("div")
    errorDiv.className = "bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700"
    errorDiv.textContent = message
    this.messagesContainerTarget.appendChild(errorDiv)
    this.scrollToBottom()
  }

  scrollToBottom() {
    if (this.hasMessagesContainerTarget) {
      this.messagesContainerTarget.scrollTop = this.messagesContainerTarget.scrollHeight
    }
  }

  // Called when new content is added via Turbo Streams
  messagesContainerTargetConnected() {
    this.scrollToBottom()
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
